import { useModelService } from 'services/model/model.service';
import { measureKpi, InfoDrawerKpiEntry } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';

function useTopReturnedProductsKpis(): InfoDrawerKpiEntry[] {
  const { getMeasures } = useModelService();

  const [retQty, retQtyRate, retGmvVal, slsQty, netSlsGmvVal] = getMeasures([
    'retQtyExpOD',
    'retQtyRateExpOD',
    'retGmvValExpOD',
    'slsQtyOD',
    'netSlsGmvValExpOD',
  ]);

  return [
    measureKpi(retQty),
    measureKpi(slsQty),
    measureKpi(retGmvVal),
    measureKpi(netSlsGmvVal),
    measureKpi(retQtyRate),
  ];
}

export function TopReturnedProductsInfoContent() {
  const kpis = useTopReturnedProductsKpis();

  return (
    <InfoDrawerKpis.Default
      kpis={kpis}
      whyUsefulTitleId="info.content.why_is_it_useful"
      whyUsefulDescriptionId="insights.marketplace_tab.top_returned_products.report.why_is_it_useful"
      showOrderBasedNote
    >
      <hr className="my-4 border-snow-200" />
      <InfoContentItem
        titleId="info.content.data_availability"
        descriptionId="info.content.data_availability.description"
      />
    </InfoDrawerKpis.Default>
  );
}
